import { render } from "./UsdPaymentButton.vue?vue&type=template&id=74c2afce"
import script from "./UsdPaymentButton.vue?vue&type=script&lang=js"
export * from "./UsdPaymentButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__